<div class="d-inline-block" ngbDropdown #myDrop="ngbDropdown">

    <button type="button" class="btn btn-primary btn-sm" id="dropdownManual" ngbDropdownAnchor (focus)="myDrop.open()"> Выберите действие <span *ngIf=""></span> ({{selectedFiles}}{{countSelectedFiles}}) </button>

    <div *ngIf="actionListData != null">
        <div ngbDropdownMenu aria-labelledby="dropdownManual">
            <div class="dropdown-item" *ngFor="let item of actionListData" (click)="getAction(item.id)"> 
                {{item.name}}
            </div>
        </div>
    </div>
</div>